module.exports = __webpack_public_path__ + "media/images/tailwind/search-icon-5f66ae79d566479244108eca6f08b851.png";